<template>
  <div>
    <div id="blog" class="container">
      <section>
        <div class="section-group">
          <div class="row">
            <div class="row row-cols-1 row-cols-sm-1 col-lg-1 g-1">
              <menuVue ref="menu" @changeMenu="changeMenu"></menuVue>
            </div>
            <router-view></router-view>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import menuVue from "@/components/blog/menu";
export default {
  components: { menuVue },
  methods: {
    setCurrent(ix) {
      this.$refs.menu.setCurrent(ix);
    },
    changeMenu(id, name) {
      if (id === -1) {
        this.$router.push({
          name: "blogAll",
        });
      } else {
        this.$router.push({
          name: "blogCategory",
          query: {
            categoryId: id,
            cateName: name,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/blog/index.vue